import { ExtendedAttributeCategoryEnum } from '../enums/extended-attribute-category.enum';
import { ExtendedAttribute } from './extended-attribute';

export class ExtendedAttributeCommand {
    name: string;
    type: number;
    visible: boolean;
    editable: boolean;
    shared_by_default: boolean;
    sort: number;
    options_enabled: boolean;
    'translation_en-GB': string;
    'translation_de-DE': string;
    'translation_fr-FR': string;
    'translation_it-CH': string;
    category: ExtendedAttributeCategoryEnum;
    mandatory?: boolean;
    enabled_for?: {
        course: true;
        program: true;
        e_learning: true;
    };

    constructor(model: ExtendedAttribute) {
        this.name = model.name;
        this.type = model.type;
        this.visible = model.visible;
        this.editable = model.editable;
        this.shared_by_default = model.sharedByDefault;
        this.sort = model.sort;
        this.options_enabled = model.optionsEnabled;
        this['translation_en-GB'] = model['translation_en-GB'];
        this['translation_de-DE'] = model['translation_de-DE'];
        this['translation_fr-FR'] = model['translation_fr-FR'];
        this['translation_it-CH'] = model['translation_it-CH'];
        this.category = model.category;
        this.mandatory = model.mandatory;
        if (model.enabledFor) {
            this.enabled_for = {
                course: model.enabledFor.course,
                program: model.enabledFor.program,
                e_learning: model.enabledFor.eLearning,
            };
        }
    }
}
